import { Avatar } from "@material-ui/core";
import { ReactComponent as ContactAvatar } from "assets/icons/contact.svg";
import MemberDrawerSvg from "assets/icons/svg/memberIcon";
import ReturnSvgComponent from "assets/icons/svg/returnSvg";
import RightArrowSvg from "assets/icons/svg/RightArrowSvg";
import React from "react";
import Select, { components } from "react-select";
import { HintField } from "..";
import "./index.scss";
export const AsyncAutoCompleteField = ({
  handleInputChange,
  handleChange,
  touched,
  error,
  active = true,
  ...props
}) => {
  const formatOptionLabel = ({ label, id, profile_img, address }) => {
    return (
      <div className="dropdown-container" key={id}>
        {id && label && (
          <div className="dropdown-member-icon">
            <ContactAvatar fillcolor={"#2555ef"} height={20} width={20} />
          </div>
        )}
        <div className="icon-name-container">
          {/* {profile_img ? (
            <img
              height={40}
              width={40}
              className="rounded-circle"
              src={profile_img}
              alt="profileImg"
            />
          ) : (
            <Avatar style={{ width: 30, height: 30 }}>
              {label?.charAt(0)}
            </Avatar>
          )} */}
          <div className="name-container">
            <div>{label}</div>
            {active && < div className="id-container">{address === null ? id === undefined ? '-' : '#' + id : address}</div>}
          </div>
        </div>
        {
          id && label && (
            <div className="return-icon">
              <ReturnSvgComponent width={24} height={24} />
            </div>
          )
        }
      </div >
    );
  };
  const selectControlStyles = {
    backgroundColor: "#F3F6F9",
    borderColor: "#F3F6F9",
    color: "#3F4254",
    transition:
      "color 0.15s ease, background-color 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease",
    // paddingTop: "8px",
    // paddingBottom: "8px",
    height: "48px",
  };
  const colourStyles = {
    control: (styles) => ({
      ...styles,
      ...selectControlStyles,
      ...props.style,
      "&:hover": {
        cursor: "pointer",
        backgroundColor: "#d9e4f6",
      },
    }),
    option: (styles) => {
      return {
        "&:hover": {
          cursor: "pointer",
        },
        ...styles,
      };
    },
    menu: (styles) => {
      return {
        ...styles,
      };
    },
    menuList: (styles) => ({
      ...styles,
      maxHeight: "120px",
    }),
    IndicatorSeparator: (styles) => ({ display: "none" }),
  };
  const DropdownIndicator = (props) => {
    return (
      <components.DropdownIndicator {...props}>
        <RightArrowSvg label="Emoji" />
      </components.DropdownIndicator>
    );
  };
  return (
    <div>
      <Select
        onInputChange={(text) => handleInputChange(text)}
        formatOptionLabel={formatOptionLabel}
        styles={colourStyles}
        onChange={handleChange}
        components={{ DropdownIndicator }}
        {...props}
      />
      {touched && error ? <HintField error={error} /> : null}
    </div>
  );
};